export const RANGES = [
  ["2w", "2 weeks"], ["1m", "1 month"], ["3m", "3 months"], ["6m", "6 months"],
  ["9m", "9 months"], ["12m", "12 months"], ["all", "All (24 months)"],
];

const DAYS_PER_MONTH = 30.44;
// [unit days, days back, days ahead]; monthly ranges slice the real month-end points instead.
const FINE = { "2w": [1, 7, 14], "1m": [1, 10, 31], "3m": [7, 28, 91], "6m": [7, 56, 182] };
const MONTHLY = { "9m": [2, 9], "12m": [3, 12] };

const lerp = (pts, t) => {
  for (let i = 0; i < pts.length - 1; i++) {
    const [t0, v0] = pts[i];
    const [t1, v1] = pts[i + 1];
    if (t >= t0 && t <= t1) return t1 === t0 ? v0 : v0 + ((v1 - v0) * (t - t0)) / (t1 - t0);
  }
  return null;
};

const label = (days) => new Date(Date.now() + days * 864e5).toLocaleDateString("en-US", { month: "short", day: "numeric" });

export const resample = (series, range) => {
  const now = series.findIndex((r) => r.actual != null && r.forecast != null);
  const withDays = series.map((r, i) => ({ ...r, days: (i - now) * DAYS_PER_MONTH }));
  if (range === "all" || now < 0) return withDays;
  if (MONTHLY[range]) {
    const [back, ahead] = MONTHLY[range];
    return withDays.slice(Math.max(0, now - back), now + ahead + 1);
  }
  const [step, back, ahead] = FINE[range];
  const keys = [...new Set(series.flatMap((r) => Object.keys(r)))].filter((k) => k !== "month" && k !== "days");
  const pts = Object.fromEntries(keys.map((k) => [k, series.map((r, i) => [i - now, r[k]]).filter(([, v]) => v != null)]));
  const out = [];
  for (let d = -back; d <= ahead; d += step) {
    const t = d / DAYS_PER_MONTH;
    const row = { month: d === 0 ? "Today" : label(d), days: d };
    keys.forEach((k) => {
      if ((k === "actual" && d > 0) || (k !== "actual" && d < 0)) return;
      const v = lerp(pts[k], t);
      if (v != null) row[k] = Math.round(v * 100) / 100;
    });
    out.push(row);
  }
  return out;
};

// Closest point to the zero-cash date, only when that date is inside the visible range.
export const zeroCashPoint = (rows, isoDate) => {
  if (!isoDate || !rows.length) return null;
  const today = new Date(new Date().toISOString().slice(0, 10));
  const zdays = (new Date(isoDate) - today) / 864e5;
  if (zdays < rows[0].days || zdays > rows[rows.length - 1].days) return null;
  return rows.reduce((best, r) => (Math.abs(r.days - zdays) < Math.abs(best.days - zdays) ? r : best), rows[0]);
};

export const withLastWeek = (series, snapshot) => {
  if (!snapshot?.available) return series;
  const byMonth = Object.fromEntries(snapshot.points.map((p) => [p.month, p.forecast]));
  return series.map((r) => (r.forecast != null && byMonth[r.month] != null ? { ...r, lw: byMonth[r.month] } : r));
};
